import style from './Object.module.css';

import InfoIcon from 'assets/svg/icon_info-01.svg';

import { PUBLIC_ASSETS, address_server_short } from 'config';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import Icon from 'ui/Icon';
import RegularButton from 'ui/RegularButton';
import ModalSelectSample from 'components/Modals/ModalSelectSample/idnex';
import Tooltip from 'ui/Tooltip';
import FormTextField from 'ui/formItems/FormTextField';
import FormAutocomplete from 'ui/formItems/FormAutocomplete';
import { getSamplesSourcesByType } from 'services/list.services';

const ExternalObject = ({ object, index }) => {
  const { setValue } = useFormContext();

  const [selectedItems, setSelectedItems] = useState(null);
  const [open, setOpen] = useState(false);

  const [source, setSource] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    setValue(`objects.[${index}].id`, object.id);
    setValue(`objects.[${index}].type`, object.type);
    setValue(`objects.[${index}].derived`, object.derived);
    if (object.value !== null) {
      if (object.type === 'type_samples')
        setValue(`objects.[${index}].value.volume`, object?.value?.volume?.amount);
      setValue(`objects.[${index}].value.id`, object?.value?.id);
    }
  }, []);

  const onClose = () => {
    setOpen(false);
  };

  const handlerSearch = async (searchStr) => {
    try {
      const { type, id } = object;
      if (type === 'type_sample_sources') {
        const sources = await getSamplesSourcesByType(id, searchStr);
        setSource(sources.data ?? []);
        return;
      }
    } catch (e) {
      setSource([]);
    }
  };

  const Line = () => {
    return (
      <div
        style={{
          width: '40px',
          height: '40px',
          marginLeft: '22px',
        }}
      >
        <div
          style={{
            borderBottom: '3px solid grey',
            borderLeft: '3px solid grey',
            width: '40px',
            height: '20px',
          }}
        ></div>
      </div>
    );
  };

  const EmptySample = () => {
    return <div className={style.emptyText}>Не выбрано</div>;
  };

  return (
    <div className={style.objectExternalContainer}>
      {object?.type !== 'type_sample_sources' && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
          }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div className={style.objectIconContainer}>
              <Icon
                width="44px"
                height="44px"
                src={address_server_short + PUBLIC_ASSETS + (object?.image ?? '')}
              />
              <div>{object?.name}</div>
            </div>
            <div>
              <RegularButton
                text={'Выбрать'}
                variant={'flat'}
                onClick={() => {
                  setOpen(true);
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            <Line />
            {selectedItems === null ? (
              <EmptySample />
            ) : (
              <div
                style={{
                  display: 'flex',
                  gap: '1rem',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <div>ID:{selectedItems?.[0]?.id}</div>
                <div>Штрихкод: {selectedItems?.[0]?.barcode_value ?? 'Нет'}</div>
                <div>
                  <Tooltip text={selectedItems?.[0]?.locations?.path?.toString() ?? '1234'}>
                    <Icon src={InfoIcon} />
                  </Tooltip>
                </div>
                <div
                  style={{
                    display: 'flex',
                    marginLeft: 'auto',
                    marginRight: ' 10px',
                    width: '300px',
                  }}
                >
                  <FormTextField
                    name={`objects.[${index}].value.volume`}
                    defaultValue={
                      selectedItems?.[0]?.volume?.amount
                        ? Number(selectedItems?.[0]?.volume.amount)
                        : 0
                    }
                    min={0}
                    hideErrorBlock
                    label="Количество:"
                    max={
                      selectedItems?.[0]?.volume?.amount
                        ? Number(selectedItems?.[0]?.volume.amount)
                        : 0
                    }
                    type={'number'}
                    step={0.1}
                  />
                  <div className={style.objectUnit}>
                    {selectedItems?.[0] && selectedItems?.[0]?.volume?.unit_name}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {object?.type === 'type_sample_sources' && (
        <div className={style.objectContainer}>
          <div className={style.objectIconContainer}>
            <Icon
              width="44px"
              height="44px"
              src={address_server_short + PUBLIC_ASSETS + (object?.image ?? '')}
            />
            <div>{object?.name}</div>
          </div>
          <div className={style.objectAutocomplete}>
            <FormAutocomplete
              name={`objects.[${index}].value.id`}
              items={source}
              placeholder="Введите название источника образца..."
              keyItem={'id'}
              valueItem={'name'}
              hideErrorBlock
              onChange={handlerSearch}
              renderOption={
                object?.type === 'type_samples'
                  ? (value) =>
                      `ID: ${value?.id_general}${value.barcode ? ` - Штрихкод: ${value.barcode.value}` : ''}`
                  : undefined
              }
              minValueForSearch={1}
            />
          </div>
        </div>
      )}

      {open && (
        <ModalSelectSample
          open={open}
          onClose={onClose}
          submit={(props) => {
            setValue(`objects.[${index}].value.id`, props?.[0]?.id);
            setValue(`objects.[${index}].value.volume`, props?.[0]?.volume.amount);
            setSelectedItems(props);
          }}
          sampleType={object}
        />
      )}
    </div>
  );
};

export default ExternalObject;
